
import { Routes, Route } from 'react-router-dom';
import AdminLayout from '@/layouts/AdminLayout';
import RequireAuth from '@/components/RequireAuth';
import ThemeSettings from "@/pages/admin/ThemeSettings";
import AdminLanding from "@/pages/admin/AdminLanding";
import Login from "@/pages/auth/Login";
import ConfigPage from "@/pages/admin/Config";
import HotelProfile from '@/pages/admin/HotelProfile';
import RoomDetails from '@/pages/admin/RoomsDetails';
import RoomCreate from '@/pages/admin/RoomsDetails/form/createRoom';
import RoomUpdate from '@/pages/admin/RoomsDetails/form/editRoom';
import GoogleMap from '@/pages/admin/GoogleMap';
import GalleryPage from '@/pages/admin/Gallery';
import RateDetails from '@/pages/admin/RateDetails';
import RateUpdate from '@/pages/admin/RateDetails/form/editRate'
import HotelList from '@/pages/admin/HotelList';
import CreateHotelProfile from '@/pages/admin/HotelList/form/createHotelProfile';
import EditHotelProfile from '@/pages/admin/HotelList/form/editHotelProfile';

export default function AdminRoutes() {
  return (
    <Routes>
      <Route
        element={
          <RequireAuth>
            <AdminLayout />
          </RequireAuth>
        }

      >
        <Route path="/:propcode/admin" element={<AdminLanding />} />
        <Route path="/:propcode/admin/hotel-list" element={<HotelList />} />
        <Route path="/:propcode/admin/hotel-list/create" element={<CreateHotelProfile />} />
        <Route path="/:propcode/admin/hotel-list/:hotelId/edit" element={<EditHotelProfile />} />
        <Route path="/:propcode/admin/theme" element={<ThemeSettings />} />
        <Route path="/:propcode/admin/config" element={<ConfigPage />} />
        <Route path="/:propcode/admin/contents/hotel" element={<HotelProfile />} />
        <Route path="/:propcode/admin/contents/rooms" element={<RoomDetails />} />
        <Route path="/:propcode/admin/contents/rooms/create" element={<RoomCreate />} />
        <Route path="/:propcode/admin/contents/rooms/:roomCode/edit" element={<RoomUpdate />} />
        <Route path="/:propcode/admin/google-map" element={<GoogleMap />} />
        <Route path="/:propcode/admin/gallery" element={<GalleryPage />} />
        <Route path="/:propcode/admin/contents/rates" element={<RateDetails />} />
        <Route path="/:propcode/admin/contents/rates/:rateCode/edit" element={<RateUpdate />} />
      </Route>
      <Route path="/:propcode/login" element={<Login />} />
      <Route path="/:propcode" element={<Login />} />
    </Routes>
  );
}
